/* This file is autogenerated, see readme.md for instructions */
import ForceAddToRecallSvgIcon from '@bloomreach/banana-theme/icons/force-add-to-recall.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ForceAddToRecallIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ForceAddToRecallSvgIcon />
    </Icon>
  );
});

ForceAddToRecallIcon.displayName = 'ForceAddToRecallIcon';

export default ForceAddToRecallIcon;
